"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkReclassifyProductsModal = void 0;
const react_1 = require("react");
const use_bulk_actions_filter_hook_1 = require("./use-bulk-actions-filter.hook");
/**
 * Controls the state of bulk reclassify modal
 * Note that this modal can be displayed from two places:
 * - a button on bulk actions bar when some products are selected (filters are formed as usual)
 * - from a single product details modal (filter should explicitly select a single product)
 */
const useBulkReclassifyProductsModal = (_a) => {
    var _b;
    var { onBulkReclassifyComplete, selectedItemsCount } = _a, props = __rest(_a, ["onBulkReclassifyComplete", "selectedItemsCount"]);
    const [isBulkReclassifyModalOpen, setBulkReclassifyModalOpen] = (0, react_1.useState)(false);
    const bulkActionsFilter = (0, use_bulk_actions_filter_hook_1.useBulkActionsFilter)(props);
    const [singleProductId, setSingleProductId] = (0, react_1.useState)(null);
    const selectedStrategyNodeId = (_b = props === null || props === void 0 ? void 0 : props.productTreeNode) === null || _b === void 0 ? void 0 : _b.id;
    const onSuccess = () => {
        setBulkReclassifyModalOpen(false);
        onBulkReclassifyComplete();
        if (singleProductId) {
            setSingleProductId(null);
        }
    };
    const onClose = () => {
        setBulkReclassifyModalOpen(false);
        if (singleProductId) {
            setSingleProductId(null);
        }
    };
    const onReclassifySingleProduct = (productId) => {
        setBulkReclassifyModalOpen(true);
        setSingleProductId(productId);
    };
    const filterForSingleProduct = {
        product: { id: { in: [singleProductId] } },
    };
    return {
        isBulkReclassifyModalOpen,
        setBulkReclassifyModalOpen,
        onReclassifySingleProduct,
        bulkReclassifyModalProps: {
            productFilter: singleProductId ? filterForSingleProduct : bulkActionsFilter,
            selectedItemsCount: singleProductId ? 1 : selectedItemsCount,
            expectedMatchedProductCount: props.selectAllMode && !singleProductId ? selectedItemsCount : undefined,
            selectedStrategyNodeId,
            onSuccess,
            onClose,
        },
    };
};
exports.useBulkReclassifyProductsModal = useBulkReclassifyProductsModal;
